import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider } from "./AuthContext";
import MyNav from "./MyNav";
import Home from "./Home";
import Documentation from "./Documentation";
import Pricing from "./Pricing";
import ApiTokens from "./ApiTokens";
import SupportFooter from "./SupportFooter";

export default function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <Router>
          <div className="d-flex flex-column min-vh-100">
            <MyNav />
            <main className="flex-grow-1">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/home" element={<Home />} />
                <Route path="/documentation" element={<Documentation />} />
                <Route path="/pricing" element={<Pricing />} />
                <Route path="/api-tokens" element={<ApiTokens />} />
              </Routes>
            </main>
            <SupportFooter />
          </div>
        </Router>
      </AuthProvider>
    </HelmetProvider>
  );
}
